import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgDarkSpotFormulaGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M38.3 8H26.94c-.94 0-1.7.76-1.7 1.7v28.6c0 .2.08.39.22.53l.95.95c.14.14.33.22.53.22H38.3c.2 0 .39-.08.53-.22l.95-.95a.75.75 0 0 0 .22-.53V9.7c0-.94-.76-1.7-1.7-1.7ZM26.94 9.5H38.3c.11 0 .2.09.2.2v13.55H26.74V9.7c0-.11.09-.2.2-.2Zm11.05 29H27.25l-.51-.51V24.75H38.5v13.24l-.51.51ZM12.06 26.76c1.41 0 2.56 1.15 2.56 2.56 0 .41.34.75.75.75s.75-.34.75-.75c0-2.24-1.82-4.06-4.06-4.06-2.24 0-4.06 1.82-4.06 4.06 0 2.24 1.82 4.06 4.06 4.06 1.41 0 2.56 1.15 2.56 2.56 0 1.41-1.15 2.56-2.56 2.56-1.41 0-2.56-1.15-2.56-2.56 0-.41-.34-.75-.75-.75s-.75.34-.75.75C8 38.18 9.82 40 12.06 40c2.24 0 4.06-1.82 4.06-4.06 0-2.24-1.82-4.06-4.06-4.06-1.41 0-2.56-1.15-2.56-2.56 0-1.41 1.15-2.56 2.56-2.56ZM12.06 8H8.75c-.41 0-.75.34-.75.75v13.24c0 .41.34.75.75.75h3.31c2.24 0 4.06-1.82 4.06-4.06v-6.62A4.05 4.05 0 0 0 12.06 8Zm2.57 10.68c0 1.41-1.15 2.56-2.56 2.56H9.5V9.5h2.56c1.41 0 2.56 1.15 2.56 2.56v6.62h.01Z",
    fill: "currentColor"
  }));
}

export { SvgDarkSpotFormulaGlyphSecondary as default };
